import { useContext } from 'react'

import Swal from 'sweetalert2'

import { faLock, faUnlock } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Box, Button, Text } from '@domain-group/suit-theme'

import type { UseBrandPayload } from '@hooks/useBrand'

import { BrandModel } from '@domain-group/realhub-backend-api-types'

import PageContext from '@contexts/pageContext'

interface ConfirmArchiveProps {
  brand: BrandModel,
  updateBrand: (payload: object) => Promise<object>,
  updateFn: (payload: object) => Promise<object>,
}

const confirmActivate = (params: ConfirmArchiveProps) => {
  const {
    brand: {
      id,
    },
    updateBrand,
    updateFn,
  } = params

  const brandActivatePayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: { id, hidden: false },
    toastText: 'Brand Marked as Active',
  }

  Swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, mark as active.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Mark Brand as Active?',
  })
    .then(({ value }) => {
      if (value){
        updateBrand(brandActivatePayload)
      }
    })
}

type AgencyLockedBannerProps = {
  brandPayload: UseBrandPayload,
}

const BrandInactiveBanner = (props: AgencyLockedBannerProps) => {
  const { brandPayload } = props
  const { brand, callbacks: { updateBrand: updateFn } } = brandPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updateBrand,
    },
  } = pageContext

  return (
    <Box alignItems="center" flexDirection={['column', 'row']} marginBottom="large" padding="large" variant="white">
      <Box>
        <Box
          backgroundColor="pink"
          borderRadius={5}
          color="red"
          fontSize="large"
          padding="large"
          width="fit-content"
        >
          <FontAwesomeIcon icon={faLock} />
        </Box>

        <Box flexDirection="column" justifyContent="center" marginLeft="large">
          <Text fontSize="small">Brand Marked as Inactive</Text>
        </Box>
      </Box>

      <Button
        buttonStyle="secondaryUtility"
        //@ts-expect-error
        height="fit-content"
        icon={<FontAwesomeIcon icon={faUnlock} />}
        marginTop={['large', 0]}
        onClick={() => confirmActivate({ updateFn, updateBrand, brand })}
        size="medium"
        width={['100%', 'fit-content']}
      >
        Activate Brand
      </Button>
    </Box>
  )
}

export default BrandInactiveBanner
